export * from './order-details.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/order/index.ts